import axios from "axios";
import { PiletConfig } from "../types/pilet";
import { piletConfig } from "../constants/pilet";
import { getAPIMSubscriptionKey, getIdTokenNoCache } from "./auth";
import { APIMSubscriptionKeyHeader } from "../constants/auth";

export async function fetchPiletConfig(tenantId: string, userId: string) {
  console.log("Fetching pilet for tenant : ", tenantId);
  const token = await getIdTokenNoCache();
  const subscriptionResponse = await getAPIMSubscriptionKey(token);
  const response = await axios.get<PiletConfig>(piletConfig.feedUrl, {
    headers: {
      Authorization: `Bearer ${token}`,
      [APIMSubscriptionKeyHeader]: subscriptionResponse.SubscriptionKey,
    },
  });
  const piletData = response.data;
  return piletData.pilet;
}
